
export const tabs = [

	{
		title: 'Recharge',
		icon: 'IconMobileRecharge',
		id: 'tab1',
		 show: 'all',
		apiPermission: 'MOBILE',
	},

	{
		title: 'Credit Card',
		icon: 'IconCreditCard',
		id: 'tab3',
		show: 'all',
		apiPermission: 'BBPS',
	},
	{
		title: 'Add Money',
		icon: 'IconAddmoney',
		id: 'tab8',
		show: 'all',
		apiPermission: 'OTHERS',
	},

	// {
	// 	title: 'AEPS1',
	// 	icon: 'IconAEPS',
	// 	id: 'tab6',
	// 	show: 'login',
	// 	apiPermission: 'AEPS',
	// },
	{
		title: 'AEPS',
		icon: 'IconAEPS',
		id: 'tab12',
		show: 'login',
		apiPermission: 'AEPS_2',
	},
	// {
	// 	title: 'Aadhar Pay',
	// 	icon: 'IconAadhayPay',
	// 	id: 'tab11',
	// 	show: 'login',
	// 	apiPermission: 'AEPS',
	// },


	// This is DMT1 only i change name DMT1 to DMT(only change DMT1 to DMT)
	{
		title: 'DMT',
		icon: 'IconSendmoney',
		id: 'tab7',
		show:'login',
		apiPermission:'SEND_MONEY',
	},


	//DMT is not working
	// {
	// 	title: 'DMT',
	// 	icon: 'IconSendmoney',
	// 	id: 'tab14',
	// 	show:'login',
	// 	apiPermission:'SEND_MONEY',
	// },

	{
		title: 'DTH',
		icon: 'IconDTH',
		id: 'tab5',
		show: 'all',
		apiPermission: 'BBPS',
	},
	{
		title: 'Electricity',
		icon: 'IconBillRecharge',
		id: 'tab2',
		show: 'all',
		apiPermission: 'BBPS',
	},
	{
		title: 'Broadband',
		icon: 'IconBroadband',
		id: 'tab4',
		show: 'all',
		apiPermission: 'BBPS',
	},

	
	{
		title: 'Water',
		icon: 'IconWater',
		id: 'tab10',
		show: 'all',
		apiPermission: 'BBPS',
	},
	// {
	// 	title: 'DQR',
	// 	icon: 'IconAEPS',
	// 	id: 'tab12',
	// 	show: 'login',
	// 	apiPermission: 'AEPS',
	// },
];
